import { HStack, Input, Text, VStack, Flex } from "@chakra-ui/react";
import { ru } from "date-fns/locale";
import { observer } from "mobx-react-lite";
import DatePicker from "react-datepicker";
import { useStores } from "../store/store_context";

const SelectDateYear = observer(() => {
  const { pageStore } = useStores();

  const getStartOfYear = (date) => {
    const year = date.getFullYear();
    return new Date(year, 0, 1); // 1 января
  };

  const getEndOfYear = (date) => {
    const year = date.getFullYear();
    return new Date(year, 11, 31); // 31 декабря
  };

  return (
    <VStack padding="10px" width="100%">
      <Flex
        direction={{ base: "column", md: "row" }} // В колонку на мобильных, в ряд на ПК
        align="center"
        gap={2}
        width="100%"
        justify="center"
      >
        <DatePicker
          selected={pageStore.start_date_year}
          onChange={(date) => {
            if (date) {
              pageStore.updateStartDateYear(getStartOfYear(date));
              pageStore.updateStartDateMonth("");
              pageStore.updateEndDateMonth("");
              pageStore.updateStartDateDay("");
              pageStore.updateEndDateDay("");
            }
          }}
          showYearPicker
          dateFormat="yyyy"
          locale={ru}
          placeholderText="выберите год начала"
          customInput={
            <Input
              style={{
                width: "240px",
                border: "none",
                background: "#333",
                color: "#EEEEEE",
                borderRadius: "10px",
                fontWeight: 600,
              }}
            />
          }
        />

        <Text fontWeight={600} color="myColor.white">
          —
        </Text>

        <DatePicker
          selected={pageStore.end_date_year}
          onChange={(date) => {
            if (date) {
              pageStore.updateEndDateYear(getEndOfYear(date));
              pageStore.updateStartDateMonth("");
              pageStore.updateEndDateMonth("");
              pageStore.updateStartDateDay("");
              pageStore.updateEndDateDay("");
            }
          }}
          showYearPicker
          dateFormat="yyyy"
          locale={ru}
          placeholderText="выберите год конца"
          customInput={
            <Input
              style={{
                width: "240px",
                border: "none",
                background: "#333",
                color: "#EEEEEE",
                borderRadius: "10px",
                fontWeight: 600,
              }}
            />
          }
        />
      </Flex>
    </VStack>
  );
});

export default SelectDateYear;